import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';

export class MagicLampsGenie extends View {
  private base: ImageScaleView;

  constructor(opts: ViewOpts) {
    super({ ...opts });

    this.base = new ImageScaleView({
      superview: this,
      width: 168,
      height: 218,
      image: `assets/ui/match2/magiclamps/magiclamps_genie.png`,
      centerAnchor: true,
      centerOnOrigin: true,
    });
  }
}
